// frontend_app/src/lib/text.js

// Same rule as backend_api/tools/sanitize.py: a value is HTML only if it
// contains a complete tag (or a comment). "Result < 5" stays plain text.
const HTML_TAG_RE = /<\s*\/?\s*[a-zA-Z][a-zA-Z0-9-]*(\s[^<>]*)?\/?\s*>|<!--/;

export const looksLikeHtml = (value) => typeof value === 'string' && HTML_TAG_RE.test(value);

const ENTITY_MAP = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: ' ', '#39': "'" };

const decodeEntities = (str) =>
  str.replace(/&(#x?[0-9a-f]+|[a-z]+);/gi, (match, entity) => {
    const lower = entity.toLowerCase();
    if (ENTITY_MAP[lower] !== undefined) return ENTITY_MAP[lower];
    if (lower.startsWith('#x')) return String.fromCodePoint(parseInt(lower.slice(2), 16) || 32);
    if (lower.startsWith('#')) return String.fromCodePoint(parseInt(lower.slice(1), 10) || 32);
    return match;
  });

/** Plain text from a possibly-HTML string, with block breaks turned into spaces. */
export const stripHtml = (value) => {
  if (value === null || value === undefined) return '';
  let str = String(value);
  if (looksLikeHtml(str)) {
    str = str
      .replace(/<(script|style)[\s\S]*?<\/\1>/gi, ' ')
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/<\/(p|div|li|tr|h[1-6])>/gi, ' ')
      .replace(/<[^>]*>/g, '');
  }
  return decodeEntities(str).replace(/\s+/g, ' ').trim();
};

/** Lower-case, punctuation-free, single-spaced form used for matching. */
export const normalize = (value) =>
  stripHtml(value)
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, ' ')
    .trim();

export const escapeRegExp = (str) => str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/** Words of the query worth highlighting individually (plus the whole phrase). */
export const highlightTerms = (query) => {
  const phrase = (query || '').trim();
  if (!phrase) return [];
  const words = phrase.split(/\s+/).filter((w) => w.length >= 3);
  return Array.from(new Set([phrase, ...words])).sort((a, b) => b.length - a.length);
};

export const pluralize = (count, singular, plural = `${singular}s`) =>
  `${count.toLocaleString()} ${count === 1 ? singular : plural}`;

/** Deterministic short hash (FNV-1a, base 36) for building stable ids. */
export const hashString = (str) => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < str.length; i += 1) {
    hash ^= str.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0).toString(36);
};
